import React, { useEffect, useMemo, useState } from "react";
import Layout from "../component/Layout/Layout";
import "../shopByCollection.css";
import { Link, NavLink } from "react-router-dom";

const SIL = {
  lehenga: (
    <>
      <path d="M25 24 Q32 19 39 24" />
      <path d="M25 24 L26 34 L38 34 L39 24" />
      <path d="M23 40 L14 84 L50 84 L41 40 Z" />
      <path d="M24 40 L40 40" />
      <path d="M32 41 L32 84" />
    </>
  ),
  anarkali: (
    <>
      <path d="M26 24 Q32 19 38 24" />
      <path d="M26 24 C24 42 17 62 15 85 L49 85 C47 62 40 42 38 24" />
      <path d="M21 44 Q32 49 43 44" />
    </>
  ),
  gown: (
    <>
      <path d="M27 24 Q32 20 37 24" />
      <path d="M27 24 C26 46 25 62 21 86 L43 86 C39 62 38 46 37 24" />
    </>
  ),
  sharara: (
    <>
      <path d="M25 24 Q32 19 39 24 L40 42 L24 42 Z" />
      <path d="M25 25 L19 36 M39 25 L45 36" />
      <path d="M25 44 L16 84 L31 84 L32 46" />
      <path d="M39 44 L48 84 L33 84 L32 46" />
    </>
  ),
  palazzo: (
    <>
      <path d="M25 24 Q32 19 39 24 L40 42 L24 42 Z" />
      <path d="M25 25 L19 36 M39 25 L45 36" />
      <path d="M26 44 L23 84 L31 84 L32 46" />
      <path d="M38 44 L41 84 L33 84 L32 46" />
    </>
  ),
  dhoti: (
    <>
      <path d="M25 24 Q32 19 39 24 L40 42 L24 42 Z" />
      <path d="M25 25 L19 36 M39 25 L45 36" />
      <path d="M24 44 L26 84 L38 84 L40 44" />
      <path d="M24 44 Q32 66 40 44" />
      <path d="M32 52 L32 84" />
    </>
  ),
  kaftan: (
    <>
      <path d="M22 30 L17 84 L47 84 L42 30 Z" />
      <path d="M29 30 Q32 34 35 30" />
      <path d="M22 30 L13 44 M42 30 L51 44" />
    </>
  ),
  kurtaStraight: (
    <>
      <path d="M25 24 Q32 19 39 24 L38 58 L26 58 Z" />
      <path d="M25 25 L19 38 M39 25 L45 38" />
      <path d="M28 58 L27 84 M36 58 L37 84 M27 84 L37 84" />
    </>
  ),
  kurtaAline: (
    <>
      <path d="M25 24 Q32 19 39 24 L44 60 L20 60 Z" />
      <path d="M25 25 L19 38 M39 25 L45 38" />
      <path d="M27 60 L26 84 M37 60 L38 84 M26 84 L38 84" />
    </>
  ),
  farshi: (
    <>
      <path d="M25 24 Q32 19 39 24 L40 40 L24 40 Z" />
      <path d="M25 25 L19 37 M39 25 L45 37" />
      <path d="M24 42 L11 85 L53 85 L40 42 Z" />
      <path d="M32 42 L32 85" />
    </>
  ),
  saree: (
    <>
      <path d="M27 24 Q32 20 37 24" />
      <path d="M27 24 L23 84 L43 84 L40 40" />
      <path d="M27 24 Q41 30 40 40" />
      <path d="M31 54 L30 84 M35 54 L36 84" />
    </>
  ),
  indowestern: (
    <>
      <path d="M27 24 Q32 20 37 24 L35 84 L29 84 Z" />
      <path d="M27 24 L18 52 M37 24 L47 58" />
    </>
  ),
  setGeneric: (
    <>
      <path d="M25 24 Q32 19 39 24 L40 45 L24 45 Z" />
      <path d="M25 25 L19 37 M39 25 L45 37" />
      <path d="M26 48 L25 84 L39 84 L38 48 Z" />
      <path d="M32 48 L32 84" />
    </>
  ),
  motif: (
    <>
      <path d="M35 26 C22 29 21 52 34 60 C47 55 45 37 37 35 C31 34 30 42 35 46" />
      <path d="M33 60 L33 74" />
      <path d="M33 68 Q28 66 26 61 M33 66 Q38 63 40 58" />
    </>
  ),
};

const CATALOG = {
  PRET: {
    style: [
      { name: "Farshi Salwar Sets", desc: "Regal wide-panel drama", sil: "farshi", art: "sharara" },
      { name: "Straight Kurta Sets", desc: "Clean, elongated lines", sil: "kurtaStraight" },
      { name: "Dhoti Sets", desc: "Modern draped edge", sil: "dhoti" },
      { name: "Kaftan Sets", desc: "Fluid, easy comfort", sil: "kaftan" },
      { name: "Plazzo Sets", desc: "Breezy and polished", sil: "palazzo" },
      { name: "A-Line Kurta Sets", desc: "Flattering gentle flare", sil: "kurtaAline" },
      { name: "Sharara Sets", desc: "Festive twirl volume", sil: "sharara", art: "sharara" },
      { name: "Printed Sets", desc: "Playful fresh prints", sil: "setGeneric" },
      { name: "Anarkali Sets", desc: "Floor-sweeping flare", sil: "anarkali" },
      { name: "Contemporary", desc: "Reimagined classics", sil: "indowestern" },
    ],
    collection: [
      { name: "The Ruhani Edit", desc: "Serene, muted tones", sil: "motif" },
      { name: "The Manchali Edit", desc: "Playful and spirited", sil: "motif" },
      { name: "The Glam Edit", desc: "High-shine statements", sil: "motif" },
      { name: "The Festive Flair Edit", desc: "Rich festive colour", sil: "motif" },
      { name: "Ethnic Essentials", desc: "Everyday staples", sil: "setGeneric" },
    ],
  },
  COUTURE: {
    style: [
      { name: "Lehengas", desc: "Hand-crafted, tailored", sil: "lehenga", img: "lehenga" },
      { name: "Lehenga Sarees", desc: "Saree drama, easy wear", sil: "saree", art: "lehengasaree" },
      { name: "Gowns", desc: "Sculpted couture lines", sil: "gown" },
      { name: "Sarees", desc: "Bespoke luxe drapes", sil: "saree" },
      { name: "Stitched / Drape Sarees", desc: "Pre-draped, ready fit", sil: "saree", img: "saree" },
      { name: "Indo Westerns", desc: "Indian-western fusion", sil: "indowestern" },
    ],
    collection: [
      { name: "Timeless Lehengas", desc: "Heirloom classics", sil: "lehenga", img: "lehenga" },
      { name: "Regal Lehengas", desc: "Opulent, embellished", sil: "lehenga" },
      { name: "Printed Lehengas", desc: "Light, artful prints", sil: "lehenga" },
      { name: "Mermaid Lehengas", desc: "Body-sculpting flare", sil: "lehenga" },
      { name: "Lehenga Sarees", desc: "Drape meets volume", sil: "saree", art: "lehengasaree" },
      { name: "Cocktail Lehengas", desc: "Short, contemporary", sil: "lehenga" },
      { name: "Signature Lehengas", desc: "Our defining designs", sil: "lehenga" },
      { name: "Timeless Gowns", desc: "Classic, understated", sil: "gown" },
      { name: "Mermaid Gowns", desc: "Sculpted, dramatic", sil: "gown" },
      { name: "Cocktail Gowns", desc: "Chic party lengths", sil: "gown" },
      { name: "Signature Gowns", desc: "Finest house craft", sil: "gown" },
      { name: "Timeless Sarees", desc: "Timeless couture drapes", sil: "saree" },
      { name: "Stitched / Drape Sarees", desc: "Pre-stitched, flawless", sil: "saree", img: "saree" },
      { name: "Contemporary Indian", desc: "Modern bridal classics", sil: "indowestern" },
    ],
  },
};

const TINT = {
  PRET: {
    bg: ["#F5EFE5", "#F2ECE0", "#F6F1E9", "#F1EBDF"],
    sketch: "#AD936A",
  },
  COUTURE: {
    bg: ["#F7EEF1", "#F5ECEF", "#F8F0F2", "#F4EAEE"],
    sketch: "#BC8399",
  },
};

const TIME = {
  RTS: { label: "1–2 weeks" },
  MTO: { label: "3 or more weeks" },
};

const BROWSE = {
  style: "By Style",
  collection: "By Collection",
};

function FastIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M13 2 L4 14 h6 l-1 8 9-12 h-6 z" />
    </svg>
  );
}

function TimeIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7 v5 l3 2" />
    </svg>
  );
}

function ResetIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 12a9 9 0 1 0 3-6.7" />
      <path d="M3 4 v4 h4" />
    </svg>
  );
}

function StyleIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 8.5V7.2a1.6 1.6 0 1 1 2.2 1.5" />
      <path d="M12 8.5 3.8 14c-.8.5-.4 1.7.5 1.7h15.4c.9 0 1.3-1.2.5-1.7L12 8.5Z" />
    </svg>
  );
}

function CollectionIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 4l1.7 4.6L18 10l-4.3 1.4L12 16l-1.7-4.6L6 10l4.3-1.4z" />
      <path d="M18.2 14.5l.7 1.9 1.9.7-1.9.7-.7 1.9-.7-1.9-1.9-.7 1.9-.7z" />
    </svg>
  );
}

function TagIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 12.5 12.5 4H20v7.5L11.5 20z" />
      <circle cx="16" cy="8" r="1.3" />
    </svg>
  );
}

function GemIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 4h12l3 5-9 11L3 9z" />
      <path d="M3 9h18M9 4 7.5 9 12 20 16.5 9 15 4" />
    </svg>
  );
}

function Silhouette({ type, sketch }) {
  return (
    <svg
      className="cx-sil"
      viewBox="0 0 64 96"
      fill="none"
      stroke={sketch}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {SIL[type] || SIL.setGeneric}
    </svg>
  );
}

function Media({ item, images, sketch }) {
  if (item.img && images?.[item.img]) {
    return <img className="cx-photo" src={images[item.img]} alt={item.name} loading="lazy" />;
  }

  if (item.art && images?.[item.art]) {
    return <img className="cx-art" src={images[item.art]} alt={item.name} loading="lazy" />;
  }

  return <Silhouette type={item.sil} sketch={sketch} />;
}

export default function ShopByCollection({
  images = typeof window !== "undefined" ? window.CX_IMAGES || {} : {},
  onContinue,
}) {
  const [timeline, setTimeline] = useState(null);
  const [browse, setBrowse] = useState(null);
  const [tier, setTier] = useState(null);
  const [selected, setSelected] = useState(new Set());
  const [toast, setToast] = useState("");

  // Category API data
  const [categoryData, setCategoryData] = useState({
    COUTURE: [],
    PRET: [],
  });

  const [loadingCategories, setLoadingCategories] = useState(false);

 
  const currentView = !timeline ? "timeline" : !browse ? "browse" : !tier ? "tier" : "grid";

  const selectedNames = useMemo(
    () => [...selected].map((key) => key.split("::")[1]),
    [selected]
  );

  const reset = () => {
    setTimeline(null);
    setBrowse(null);
    setTier(null);
    setSelected(new Set());
    setToast("");
  };

  const goBack = () => {
    setToast("");

    if (currentView === "grid") {
      setSelected(new Set());
      setTier(null);
    } else if (currentView === "tier") {
      setSelected(new Set());
      setTier(null);
      setBrowse(null);
    } else if (currentView === "browse") {
      setTimeline(null);
      setBrowse(null);
    }
  };

  const chooseTimeline = (value) => {
    setTimeline(value);
    setBrowse(null);
    setTier(null);
    setSelected(new Set());
    setToast("");
  };

  const chooseBrowse = (value) => {
    setBrowse(value);
    setTier(null);
    setSelected(new Set());
    setToast("");
  };

  const chooseTier = async (value) => {
  setTier(value);
  setSelected(new Set());
  setToast("");

  if (value === "ALL") {
    return;
  }

  const categoryType = value === "PRET" ? 2 : 1;

  try {
    setLoadingCategories(true);

    const response = await fetch(
                                  `${process.env.REACT_APP_API_URL}/products/category-type/${categoryType}`
                                );

    if (!response.ok) {
      throw new Error("Failed to fetch category data");
    }

    const result = await response.json();

    console.log(`${value} API Response:`, result);

    setCategoryData((prev) => ({
      ...prev,
      [value]: result,
    }));
  } catch (error) {
    console.error("Category API Error:", error);
    setToast("Unable to load categories.");
  } finally {
    setLoadingCategories(false);
  }
};

  const toggleSelection = (group, name) => {
    const key = `${group}::${name}`;

    setSelected((previous) => {
      const next = new Set(previous);

      if (next.has(key)) next.delete(key);
      else next.add(key);

      return next;
    });

    setToast("");
  };

const handleContinue = () => {
  const selectedValues = [...document.querySelectorAll('button[name="cat[]"].is-sel')]
    .map(button => button.value).join('_');
    const queryData = {
      timeline: timeline.toLowerCase(),
      browse,
      tier,
      selected: selectedValues,
    };
  const link = `/category/${queryData?.timeline}?orderBy=default&${queryData?.timeline}=1&category_product=${queryData?.selected}`;
  window.open(link, '_blank', 'noopener,noreferrer');
  
}


const handleContinue_old = () => {
  if (!selected.size) return;

  const selectedCategoryData = [...selected].map((key) => {
    const [group, ...nameParts] = key.split("::");
    const name = nameParts.join("::");

    const categories = categoryData[group] || [];

    // Find selected category from API response
    const category = categories.find(
      (item) =>
        //item.name === name ||
        //item.category_name === name ||
        //item.title === name
        item.slug
    );

    return {
      //group,
      name,
      data: category || null,
    };
    
  });

  const queryData = {
    timeline,
    browse,
    tier,
    selected: selectedCategoryData,
  };

  console.log("Final query data:", queryData);
  const allslug = queryData?.selected?.map((item) => item?.data?.slug).join('-');
  console.log("Final selected data:", allslug);

  const params = new URLSearchParams();

  params.set("timeline", timeline || "");
  params.set("browse", browse || "");
  params.set("tier", tier || "");

  // Store complete selected category data
  params.set(
    "categories",
    JSON.stringify(selectedCategoryData)
  );

  const url = `${window.location.pathname}?${params.toString()}`;

  window.history.pushState({}, "", url);

  setToast(
    `Showing your selection: ${selectedCategoryData
      .map((item) => item.name)
      .join(", ")}.`
  );

  onContinue?.(queryData);
};

  const renderCrumb = (label, onClick, isCouture = false) => (
    <button
      type="button"
      className={`cx-crumb${isCouture ? " is-couture" : ""}`}
      onClick={onClick}
    >
      <span className="dot" />
      {label}
    </button>
  );

  const renderThread = () => {
    if (!timeline) return null;

    const items = [
      {
        label: TIME[timeline].label,
        onClick: () => chooseTimeline(timeline),
      },
    ];

    if (browse) {
      items.push({
        label: BROWSE[browse],
        onClick: () => chooseBrowse(browse),
      });
    }

    if (tier) {
      items.push({
        label: tier === "PRET" ? "Prêt" : "Couture",
        onClick: () => chooseTier(tier),
        isCouture: tier === "COUTURE",
      });
    }

    return (
      <div className="cx-thread">
        {items.map((item, index) => (
          <React.Fragment key={`${item.label}-${index}`}>
            {index > 0 && <span className="cx-stitch" />}
            {renderCrumb(item.label, item.onClick, item.isCouture)}
          </React.Fragment>
        ))}
      </div>
    );
  };

  const renderFooter = () => {
    if (currentView === "timeline") return null;

    return (
      <>
        <div className="cx-foot">
          <button type="button" className="cx-link" onClick={goBack}>
            ← Back
          </button>

          <button type="button" className="cx-link" onClick={reset}>
            <span className="cx-lico">
              <ResetIcon />
            </span>
            Start over
          </button>
        </div>

        {currentView !== "all" && (
          <div className="cx-link-box">
          {/* <button
            type="button"
            className="cx-alllink"
            onClick={() => {
              setBrowse(null);
              setSelected(new Set());
              setToast("");
              setTier("ALL");
            }}
          >
            I want to see the entire collection
          </button> */}
          <a
            href="/category/shop?orderBy=default"
            className="cx-alllink"
            target="_blank"         
          >
            I want to see the entire collection
          </a>
          </div>
        )}
      </>
    );
  };

  const renderCard = ({ icon, title, note, onClick, className = "" }) => (
    <button type="button" className={`cx-card ${className}`} onClick={onClick}>
      <span className="cx-ico">{icon}</span>
      <span className="cx-time">{title}</span>
      <span className="cx-note">{note}</span>
    </button>
  );

  const renderGrid = (showAll = false) => {
    const groups = showAll ? ["PRET", "COUTURE"] : [tier];
    const word = browse === "style" ? "styles" : "edits";

    return (
      <div className="cx-screen">
        <div className="cx-q">
          <h2>
            {showAll ? (
              <>
                The <em>entire collection</em>
              </>
            ) : (
              <>
                Choose your <em>{word}</em>
              </>
            )}
          </h2>

          <div className="cx-hint">
            {showAll
              ? "Everything we make. Pick as many as you like."
              : "Pick as many as you like."}
          </div>
        </div>

        {groups.map((group) => {
  const tint = TINT[group];
  const items = categoryData[group] || [];

  return (
    <div className={`cx-group g-${group}`} key={group}>
      <div className="cx-glabel">{group}</div>

      <div className="cx-grid">
        {items.map((item, index) => {
          const key = `${group}::${item.name}`;
          const isSelected = selected.has(key);
          const background = tint.bg[index % tint.bg.length];

          return (
            <button
              type="button"
              key={key}
              className={`cx-tile${
                group === "COUTURE" ? " couture" : ""
              }${isSelected ? " is-sel" : ""}`}
              style={{
                "--tint": background,
                "--sketch": tint.sketch,
              }}
              onClick={() => toggleSelection(group, item.name)}
              value={item.slug}
              name="cat[]"
            >
              <span className="cx-panel">
                {/* <Media
                  item={item}
                  images={item.icon}
                  sketch={tint.sketch}
                /> */}
                <img src={`${process.env.REACT_APP_IMAGE_URL}category/${item.icon}`} alt="" />
                <span className="cx-check" />
              </span>

              <span className="cx-tname">{item.name}</span>
              <span className="cx-tdesc">{item.description}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
})}

        <div className="cx-selbar">
          <button
            type="button"
            className="cx-cta"
            disabled={!selected.size}
            onClick={handleContinue}
          >
            {selected.size
              ? `Continue with ${selected.size} selected`
              : "Continue"}
          </button>
        </div>
      </div>
    );
  };

  let content;

  if (!timeline) {
    content = (
      <div className="cx-screen">
        <div className="cx-q">
          <div className="kick">First things first</div>
          <h2>
            How soon would you like to <em>wear the outfit?</em>
          </h2>
        </div>

        <div className="cx-choices">
          {renderCard({
            icon: <FastIcon />,
            title: "1–2 weeks",
            note: "Only Ready to Ship (RTS) outfits will be displayed",
            onClick: () => chooseTimeline("RTS"),
          })}

          {renderCard({
            icon: <TimeIcon />,
            title: "3 or more weeks",
            note: "Ready-to-Ship (RTS) and Made-to-Order (MTO) items will be displayed.",
            onClick: () => chooseTimeline("MTO"),
          })}
        </div>
      </div>
    );
  } else if (!browse) {
    content = (
      <div className="cx-screen">
        <div className="cx-q">
          <div className="cx-hello">
            {timeline === "RTS"
              ? "So, you'd like the outfit within 1–2 weeks. Sounds good!"
              : "So, you've got a little more time to plan. Wonderful!"}
          </div>

          <h2>
            How would you like to <em>explore?</em>
          </h2>
        </div>

        <div className="cx-choices">
          {renderCard({
            icon: <StyleIcon />,
            title: "Shop by Style",
            note: "Sharara Sets, Lehengas, Sarees etc.",
            onClick: () => chooseBrowse("style"),
          })}

          {renderCard({
            icon: <CollectionIcon />,
            title: "Shop by Collection",
            note: "Ruhani, Manchali, Festive Flair etc.",
            onClick: () => chooseBrowse("collection"),
          })}
        </div>
      </div>
    );
  } else if (!tier) {
    content = (
      <div className="cx-screen">
        <div className="cx-q">
          <div className="cx-hello">Lovely. Let's narrow it down —</div>
          <h2>
            Prêt or <em>Couture?</em>
          </h2>
          <div className="cx-hint">Choose one to see its pieces.</div>
        </div>

        <div className="cx-choices">
          {renderCard({
            icon: <TagIcon />,
            title: "Prêt",
            note: "Indo westerns, shararas, straight fits, suits etc.",
            className: "cx-tier-pret",
            onClick: () => chooseTier("PRET"),
          })}

          {renderCard({
            icon: <GemIcon />,
            title: "Couture",
            note: "Lehengas, Sarees, Gowns etc.",
            className: "cx-tier-couture",
            onClick: () => chooseTier("COUTURE"),
          })}
        </div>
      </div>
    );
  } else if (tier === "ALL") {
    content = renderGrid(true);
  } else {
    content = renderGrid(false);
  }

  const isAll = tier === "ALL";

  return (
    <Layout >
        <div class="site-content-wrap static-page blog-list"><div class="container">
    <div id="cx-root">
      <div className="cx-stage">
        <div className="cx-head">{renderThread()}</div>

        {content}

        <div className={`cx-toast${toast ? " show" : ""}`}>{toast}</div>

        {!isAll && renderFooter()}
        {isAll && (
          <div className="cx-foot">
            <button type="button" className="cx-link" onClick={goBack}>
              ← Back
            </button>
            <button type="button" className="cx-link" onClick={reset}>
              <span className="cx-lico">
                <ResetIcon />
              </span>
              Start over
            </button>
          </div>
        )}
      </div>
    </div>

</div>
    </div>
    </Layout>
  );
}
